import type { WLCustomerUserConfigAllTime } from '../../types/WLCustomerUserConfig';
import type { WLConfigMigrationResult } from './types';

export function migrateDefaultSymbol(config: Partial<WLCustomerUserConfigAllTime>): WLConfigMigrationResult {
  const DEFAULT_SYMBOL = 'BTC-USD';
  const symbol = config.symbol;

  if (!symbol) {
    return { config: { ...config, symbol: DEFAULT_SYMBOL }, diff: { symbol: DEFAULT_SYMBOL } };
  }

  return { config: { ...config, symbol }, diff: {} };
}
